(() => {
  let lastKnownCount = Number(
    document.querySelector('#cart-icon-bubble .cart-count-bubble [aria-hidden="true"]')?.textContent?.trim() || 0
  );
  let refreshTimer;
  let requestSequence = 0;
  let shouldPulseAfterSync = false;

  function updateCartIconCount(count) {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    let bubble = cartIcon.querySelector('.cart-count-bubble');

    if (count <= 0) {
      bubble?.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';

      const visibleCount = document.createElement('span');
      visibleCount.setAttribute('aria-hidden', 'true');

      const accessibleCount = document.createElement('span');
      accessibleCount.className = 'visually-hidden';

      bubble.append(visibleCount, accessibleCount);
      cartIcon.appendChild(bubble);
    }

    let visibleCount = bubble.querySelector('[aria-hidden="true"]');
    if (!visibleCount) {
      visibleCount = document.createElement('span');
      visibleCount.setAttribute('aria-hidden', 'true');
      bubble.prepend(visibleCount);
    }

    let accessibleCount = bubble.querySelector('.visually-hidden');
    if (!accessibleCount) {
      accessibleCount = document.createElement('span');
      accessibleCount.className = 'visually-hidden';
      bubble.appendChild(accessibleCount);
    }

    visibleCount.textContent = String(count);
    accessibleCount.textContent = count + (count === 1 ? ' item in cart' : ' items in cart');
  }

  function pulseCartIcon() {
    const applyPulse = () => {
      const cartIcon = document.getElementById('cart-icon-bubble');
      if (!cartIcon) return;
      cartIcon.classList.remove('cart-icon--added');
      void cartIcon.offsetWidth;
      cartIcon.classList.add('cart-icon--added');
      window.setTimeout(() => cartIcon.classList.remove('cart-icon--added'), 1500);
    };

    window.requestAnimationFrame(applyPulse);
  }

  async function readActualCart() {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Unable to synchronize cart icon');
    return response.json();
  }

  async function synchronizeCartIcon() {
    const sequence = ++requestSequence;

    try {
      const cart = await readActualCart();
      if (sequence !== requestSequence) return;

      const nextCount = Math.max(0, Number(cart.item_count) || 0);
      const quantityIncreased = nextCount > lastKnownCount;

      updateCartIconCount(nextCount);
      if (shouldPulseAfterSync && quantityIncreased) pulseCartIcon();

      lastKnownCount = nextCount;
      shouldPulseAfterSync = false;
    } catch (error) {
      console.error('[Cart icon quantity sync]', error);
    }
  }

  function scheduleCartIconSync(event = {}) {
    const eventCount = Number(event.cartData?.item_count);
    const eventShowsIncrease = Number.isFinite(eventCount) && eventCount > lastKnownCount;
    const knownAddSource = event.source === 'product-form' || event.source === 'quick-add';

    shouldPulseAfterSync = shouldPulseAfterSync || knownAddSource || eventShowsIncrease;
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(synchronizeCartIcon, 60);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleCartIconSync);
  }

  window.addEventListener('pageshow', synchronizeCartIcon);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') synchronizeCartIcon();
  });
})();
